import { render, staticRenderFns } from "./FoldButton.vue?vue&type=template&id=56bca9da"
import script from "./FoldButton.vue?vue&type=script&lang=js"
export * from "./FoldButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports